import { useMemo } from 'react';
import loadable from '@loadable/component';
import type { Props as GuestRegistrationModalProps } from './GuestRegistrationModal';
import { useFlag } from '@/features/unleash';
import { ROUTE_COMPANY } from '@/constants/routes';
import { getLocation } from '@ducks/location/selectors';
import { useSelector } from 'react-redux';

const GuestRegistrationModal = loadable(
  () => import('./GuestRegistrationModal'),
  {
    resolveComponent: (components) => components.GuestRegistrationModal,
  }
);

export type ExperimentVariant = 'value-prop-long-term' | 'main-screen-ticker';

export type ExperimentData = {
  ticker: string;
};

export type GuestRegistrationModalExperimentsProps =
  GuestRegistrationModalProps & {
    experimentVariant?: ExperimentVariant;
    experimentData?: ExperimentData;
  };

const GuestRegistrationModalExperiments = loadable(
  () => import('@/components/GuestRegistrationModalExperiments'),
  {
    resolveComponent: (components) =>
      components.GuestRegistrationModalExperiments,
  }
);

export const ExperimentsSwitcher = (
  props: GuestRegistrationModalExperimentsProps
) => {
  const location = useSelector(getLocation);
  //TODO @victorc clean up this switcher
  const isCompanyPage = useMemo(() => location.type === ROUTE_COMPANY, []);
  const flag = useFlag({ name: 'mono-rego-modal' });

  const isValidVariant = flag.variant.name === 'value-prop-long-term';

  const shouldShowExperiments = flag.enabled && isValidVariant;
  if (!flag.flagsReady) {
    return null;
  }

  //Show experiment variant for company page only to 100%.
  //TODO: @riccarb. Once this variant is tested 50/50 on the rest of the app,
  //change it to become control
  if (isCompanyPage) {
    return (
      <GuestRegistrationModalExperiments
        {...props}
        experimentVariant={'value-prop-long-term'}
      />
    );
  }
  if (shouldShowExperiments) {
    return (
      <GuestRegistrationModalExperiments
        {...props}
        experimentVariant={flag.variant.name as ExperimentVariant}
      />
    );
  }
  return <GuestRegistrationModal {...props} />;
};
